/**
 * Builds a new instance of the AnimateNumber component.
 * @module AnimateNumber
 * @constructor
 */

/** @lends module:AnimateNumber */
function AnimateNumber (scope, util, element, params) {
    var that = this;
    that.attribute = 'data-stry-animate-number';

    /*  Catch instantiation errors  */
    if (!scope && !util && !element && !params) { return; }  //  Registration condition
    else {
        if (!scope) { console.error('StoryStream -> AnimateNumber -> No scope provided.'); return; }
        if (!util) { console.error('StoryStream -> AnimateNumber -> No util available.'); return; }
        if (!element) { console.error('StoryStream -> AnimateNumber -> No element provided.'); return; }
        if (!params) { console.error('StoryStream -> AnimateNumber -> No params provided.'); return; }
    }
    /*  End  */

    that.elem = element;
    that.increment = null;
    that.interval = null;
    that.is_decimal = false;
    that.is_done = false;
    that.module = null;
    that.number = 0;
    that.value = null;


    /**
     * Funnel all events through this method and distribute.
     * @memberof AnimateNumber
     * @function handleEvent
     * @param {object} e - Event data.
     * @inner
     */
    var handleEvent = function(e, params) {
        var type = e.type ? e.type : (e.html ? 'renderer' : false);
        switch(type) {
            case 'viewport.scroll':

                //  Only action any animation effect if parent module is in viewport
                if (inView.is(that.module) && !that.is_done) {

                    that.is_done = true;

                    setTimeout(function() {

                        willIncrementNumber();

                    }, 1000);
                }
                break;
        }
    };


    /**
     * Function handles the incrementing number animation.
     * @memberof AnimateNumber
     * @function willIncrementNumber
     * @inner
     */
    var willIncrementNumber = function () {

        var tester = setInterval(function() {

            that.number += that.increment;

            if (that.number >= that.value) {

                that.number = that.number;

                that.elem.innerHTML = that.value;

                clearInterval(tester);
            }
            else {

                if (that.is_decimal) {

                    that.elem.innerHTML = that.number.toFixed(1);
                }
                else {

                    that.elem.innerHTML = Math.round(that.number);
                }
            }

        }, that.interval);
    };


    /**
     * Function used to initialise the application.
     * @memberof AnimateNumber
     * @function init
     * @inner
     */
    var init = function () {


        //  Locate and store the parent module (this is used to determine whether the decoration is in view).
        that.module = STRY.util.getClosest(that.elem, function(el) {
            return STRY.util.hasClass(el, 'module');
        });


        that.value = parseFloat(that.elem.innerHTML);

        if (that.elem.innerHTML.indexOf('.') > -1) {

            that.is_decimal = true;

            that.increment = 0.1;
        }
        else {

            that.increment = 1;
        }

        that.interval = Math.round(800 / (that.value / that.increment));

        that.elem.innerHTML = 0;


        //  Listeners
        scope.addEventListener('viewport.scroll', handleEvent);
    };


    init();
    return that;
}
if (typeof module !== 'undefined' && exports !== null) {
    exports.AnimateNumber = AnimateNumber;
}
